module.exports = __webpack_public_path__ + "img/history-three.c41a8c03.png";